import { Draft, isDraft, produce as immerProduce } from 'immer';

export function produce<BaseState, DraftState = Draft<BaseState>>(
  base: BaseState,
  recipe: (draft: DraftState) => void
): BaseState {
  if (isDraft(base)) {
    recipe(base as unknown as DraftState);
    return base;
  } else {
    return immerProduce(base, recipe);
  }
}
